import {mapMutations, mapGetters, mapActions} from "vuex";

export default {
    name: "exit",
    data() {
        return {}
    },
    methods: {
        ...mapMutations({
            changeShowPopUpExit: 'auth/CHANGE_POPUP_USER_EXIT'
        }),
        ...mapActions({
            logOut: 'auth/LOGOUT'
        }),
        logOutUser() {
            this.changeShowPopUpExit(false)
            this.$router.push({name: 'home'}).catch(() => {
                console.log();
            });
            this.logOut()

        },

    },
    computed: {
        ...mapGetters({}),
    }
}

